import { cn } from '@/lib/cn';
import { Merge, type LucideIcon, type LucideProps } from 'lucide-react';
import { forwardRef } from 'react';

/**
 * Lucide `Merge` rotated 90° so the arrow points right (APP-8586 / APP-8590).
 * Use this for Session Merge (and related merge) UI instead of bare `Merge`
 * from lucide-react.
 */
export const SessionMergeIcon = forwardRef<SVGSVGElement, LucideProps>(
  function SessionMergeIcon({ className, ...props }, ref) {
    return <Merge ref={ref} className={cn('rotate-90', className)} {...props} />;
  }
) as LucideIcon;
